/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type TransactionResolutionType =
  typeof TransactionResolutionType[keyof typeof TransactionResolutionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionResolutionType = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
} as const;
